import React, {useState} from 'react'
import {useDispatch} from 'react-redux'
import {NavLink} from 'react-router-dom'
import {push} from 'connected-react-router'
import createPathByFilters from '../../utils/createPathByFilters'
import trackEvent from '../../../../utils/track-event'
import dictionary from '../../../../dictionary'

/** @param {import('./SortBy').SortByProps} props */
export default function SortBy(props) {
    const {
        sort,
        filters,
        filters: {search},
        isSelect,
    } = props
    const disabled = filters.loading

    const [sortTypeValue, setSortTypeValue] = useState(filters.sort)
    const dispatch = useDispatch()

    const handleChangeOfSelect = (e) => {
        const sortType = e.target.value

        setSortTypeValue(sortType)

        const url = createPathByFilters(filters, {
            sort: sortType,
        })

        dispatch(
            push({
                pathname: url,
                search,
                hash: '',
            })
        )

        sendTracker(sortTypeValue)
    }

    const sendTracker = (sortType) => {
        const sortTypeMap = {
            admin_rating: 'rating',
            price_asc: 'price',
            moderated_date: 'date',
        }

        trackEvent({
            category: 'store button',
            action: `Sort by ${sortTypeMap[sortType]} click`,
            label: filters.combine,
        })
    }

    const links = sort.map((item, i) => {
        const path = createPathByFilters(filters, {
            sort: item.type,
        })

        return (
            <span key={i} className="sort-by__item">
                <Choose>
                    <When condition={item.type === filters.sort}>
                        <span key={i} className="sort-by__item">
                            {item.title}
                        </span>
                    </When>
                    <Otherwise>
                        <NavLink
                            to={path}
                            onClick={() => {
                                sendTracker(item.type)
                            }}
                        >
                            {item.title}
                        </NavLink>
                    </Otherwise>
                </Choose>
            </span>
        )
    })

    const select = (
        <div className="b-input-field">
            <select
                className="m-select browser-default"
                disabled={disabled}
                value={sortTypeValue}
                onChange={handleChangeOfSelect}
            >
                <For each="item" index="i" of={sort}>
                    <option key={i} value={item.type}>
                        {item.title}
                    </option>
                </For>
            </select>
        </div>
    )

    return (
        <div className="sort-by">
            <div className="sort-by__title">{dictionary.store.Sort}</div>
            <div className="sort-by__content">{isSelect ? select : links}</div>
        </div>
    )
}
